let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eSsym")).then(() => parcelRequire('hvoP7'));